import { replaceImageUrl } from './imageUtils';

// Sanitize HTML content to prevent XSS attacks
export const sanitizeHtml = htmlContent => {
    if (!htmlContent) return '';

    // Check if we're in a browser environment
    if (typeof window === 'undefined' || typeof document === 'undefined') {
        // Server-side rendering - return a basic sanitized version with image URL replacement
        return htmlContent
            .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
            .replace(/<iframe\b[^<]*(?:(?!<\/iframe>)<[^<]*)*<\/iframe>/gi, '')
            .replace(/<object\b[^<]*(?:(?!<\/object>)<[^<]*)*<\/object>/gi, '')
            .replace(/<embed\b[^<]*(?:(?!<\/embed>)<[^<]*)*<\/embed>/gi, '')
            .replace(/<form\b[^<]*(?:(?!<\/form>)<[^<]*)*<\/form>/gi, '')
            .replace(/<input\b[^>]*>/gi, '')
            .replace(/<textarea\b[^<]*(?:(?!<\/textarea>)<[^<]*)*<\/textarea>/gi, '')
            .replace(/<select\b[^<]*(?:(?!<\/select>)<[^<]*)*<\/select>/gi, '')
            .replace(/<button\b[^<]*(?:(?!<\/button>)<[^<]*)*<\/button>/gi, '')
            .replace(/\s*style\s*=\s*["'][^"']*["']/gi, '')
            .replace(/\s*on\w+\s*=\s*["'][^"']*["']/gi, '')
            .replace(/\s*href\s*=\s*["']javascript:[^"']*["']/gi, '')
            .replace(/\s*src\s*=\s*["']javascript:[^"']*["']/gi, '')
            // Replace image URLs in src attributes
            .replace(/src\s*=\s*["']([^"']*)["']/gi, (match, url) => {
                return `src="${replaceImageUrl(url)}"`;
            })
            // Replace image URLs in srcset attributes
            .replace(/srcset\s*=\s*["']([^"']*)["']/gi, (match, srcset) => {
                // Split srcset by comma and process each URL
                const urls = srcset.split(',').map(item => {
                    const parts = item.trim().split(' ');
                    if (parts[0]) {
                        // Replace the URL part
                        parts[0] = replaceImageUrl(parts[0]);
                    }
                    return parts.join(' ');
                });
                return `srcset="${urls.join(', ')}"`;
            });
    }

    // Browser environment - use DOM manipulation
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlContent;

    // Remove potentially dangerous elements and attributes
    const dangerousTags = ['script', 'iframe', 'object', 'embed', 'form', 'input', 'textarea', 'select', 'button'];
    const dangerousAttributes = ['onclick', 'onload', 'onerror', 'onmouseover', 'onfocus', 'onblur', 'onchange', 'onsubmit', 'style'];

    // Remove dangerous tags
    dangerousTags.forEach(tag => {
        const elements = tempDiv.getElementsByTagName(tag);
        while (elements.length > 0) {
            elements[0].parentNode.removeChild(elements[0]);
        }
    });

    // Remove dangerous attributes from all elements
    const allElements = tempDiv.getElementsByTagName('*');
    for (let i = 0; i < allElements.length; i++) {
        const element = allElements[i];
        dangerousAttributes.forEach(attr => {
            if (element.hasAttribute(attr)) {
                element.removeAttribute(attr);
            }
        });

        // Remove javascript: URLs from href and src attributes
        const href = element.getAttribute('href');
        const src = element.getAttribute('src');
        const srcset = element.getAttribute('srcset');

        if (href && href.toLowerCase().startsWith('javascript:')) {
            element.removeAttribute('href');
        }

        if (src && src.toLowerCase().startsWith('javascript:')) {
            element.removeAttribute('src');
        }

        // Replace image URLs in src attributes
        if (src) {
            const newSrc = replaceImageUrl(src);
            if (newSrc !== src) {
                element.setAttribute('src', newSrc);
            }
        }

        // Replace image URLs in srcset attributes
        if (srcset) {
            const urls = srcset.split(',').map(item => {
                const parts = item.trim().split(' ');
                if (parts[0]) {
                    // Replace the URL part
                    parts[0] = replaceImageUrl(parts[0]);
                }
                return parts.join(' ');
            });
            const newSrcset = urls.join(', ');
            if (newSrcset !== srcset) {
                element.setAttribute('srcset', newSrcset);
            }
        }
    }

    return tempDiv.innerHTML;
};
